// extracted by mini-css-extract-plugin
module.exports =  {"metadata":"ViD7q0SZh2oPRemjQ4te","version":"feAcUhVzNkeD5O7JLsfm","content":"eQN56H5uQgb__6KtJomU","preview":"gV873YDWn8Xq47W1E8aJ"};